import { request, response } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { Payment } from "./payment";
import { Role } from "./role";
import { checkMigrate } from "../../init/sdkInit";
import { hashString } from "../../utils/hash";
import Long from "long";
// import { request, response } from "../../proto/bundle";
export class Organization {
    constructor(
        private email: string,
        private name: string,
        private totpUri: string,
        private phone: string,
        private address: string,
        private taxId: string,
        private vatId: string,
        private regId: string,
        private orgId: Uint8Array,
        private plan: number,
        private logo: Uint8Array,
        private location: string,
        private planExpiry: number | Long,
    ) { }

    public getEmail(): string {
        return this.email;
    }
    public setEmail(email: string): void {
        this.email = email;
    }
    public getName(): string {
        return this.name;
    }
    public setName(name: string): void {
        this.name = name;
    }
    public getTotpUri(): string {
        return this.totpUri;
    }
    public setTotpUri(totpUri: string): void {
        this.totpUri = totpUri;
    }
    public getPhone(): string {
        return this.phone;
    }
    public setPhone(phone: string): void {
        this.phone = phone;
    }
    public getAddress(): string {
        return this.address;
    }
    public setAddress(address: string): void {
        this.address = address;
    }
    public getTaxId(): string {
        return this.taxId;
    }
    public setTaxId(taxId: string): void {
        this.taxId = taxId;
    }
    public getVatId(): string {
        return this.vatId;
    }
    public setVatId(vatId: string): void {
        this.vatId = vatId;
    }
    public getRegId(): string {
        return this.regId;
    }
    public setRegId(regId: string): void {
        this.regId = regId;
    }
    public getOrgId(): Uint8Array {
        return this.orgId;
    }
    public setOrgId(orgId: Uint8Array): void {
        this.orgId = orgId;
    }

    public setPLan(plan: number): void {
        this.plan = plan;
    }
    public getPlan(): number {
        return this.plan;
    }
    public setLogo(logo: Uint8Array): void {
        this.logo = logo;
    }
    public getLogo(): Uint8Array {
        return this.logo;
    }
    public setLocation(location: string): void {
        this.location = location;
    }
    public getLocation(): string {
        return this.location;
    }
    public setPlanExpiry(planExpiry: number | Long): void {
        this.planExpiry = planExpiry;
    }
    public getPlanExpiry(): number | Long | undefined {
        return this.planExpiry;
    }
    public async verify(
        emailOtp: string,
        totp: string,
        questions?: string[],
        answers?: string[]
    ): Promise<boolean> {
        const queAndAns = (questions || []).map((question, index) =>
            request.QueAndAns.create({
                question,
                answer: answers[index] || ""
            })
        );
        let verifyOrganization = request.VerifyOrganization.create({
            email: this.email,
            totp, emailOtp,
            queAndAns,
        });
        let req = request.Request.create({ id: null, reqCreateTime: Date.now(), verifyOrganization })
        const pool = await getConnectionPool();
        const VerifyOrganizationResp = await pool.sendAndWait(req);
        checkMigrate(VerifyOrganizationResp.verifyOrganization.status)

        if (VerifyOrganizationResp?.verifyOrganization?.status != 0) {
            throw new Error(VerifyOrganizationResp.verifyOrganization?.message || "Verify Organization failed");
        }

        return Promise.resolve(true);
    }

    private async createRole(
        name: string,
        permissions: number[]
    ) {
        try {
            await Role.getRole(name);
        } catch (error) {
            const permissionsStr = permissions.map(p => Role.getPermission(p));
            await Role.addRole(name, permissionsStr);
        }
    }

    public async startPayment(
        plan: number,
        isYearly: boolean,
        additionalStorage?: number,
        coupon?: string,
        gstToken?: string,
    ): Promise<Payment> {

        let initiatePayment = request.InitiatePayment.create({
            email: this.email,
            plan: plan,
            isYearly: isYearly,
            coupon: coupon,
            additionalStorage: additionalStorage,
            organization: this.name,
            gstToken: gstToken,
        });
        let req = request.Request.create({ id: null, reqCreateTime: Date.now(), initiatePayment })
        const pool = await getConnectionPool();
        const InitiatePaymentResp = await pool.sendAndWait(req);
        checkMigrate(InitiatePaymentResp.initiatePayment.status)

        if (InitiatePaymentResp?.initiatePayment?.status != 0) {
            throw new Error(InitiatePaymentResp.initiatePayment?.message || "Initiate payment failed");
        }

        if ((InitiatePaymentResp.initiatePayment?.email ?? "") === "") {
            throw new Error("No email in response for Initiate payment(Initiate payment)");
        }

        return Promise.resolve(new Payment(
            InitiatePaymentResp.initiatePayment?.orderId ?? "",
            InitiatePaymentResp.initiatePayment?.razorpayKey ?? "",
            InitiatePaymentResp.initiatePayment?.amount ?? 0
        ))
    }

    public async finishPayment(
        payment: Payment
    ): Promise<string> {
        const VerifyPayment = request.VerifyPayment.create({ orderId: payment.orderId });
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), VerifyPayment });
        const pool = await getConnectionPool();
        const VerifyPaymentResp = await pool.sendAndWait(req);
        checkMigrate(VerifyPaymentResp.verifyPayment.status)

        if (VerifyPaymentResp?.verifyPayment?.status != 0) {
            throw new Error(VerifyPaymentResp.verifyPayment?.message || "Verify Payment failed");
        }

        return Promise.resolve(VerifyPaymentResp.verifyPayment?.message || "Completed Payment");
    }

    public async remove(
        password: string
    ) {
        const hashed_password = await hashString(password)
        const removeUser = request.RemoveUser.create({ email: this.email, password: hashed_password, organization: this.name })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), removeUser })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req);
        checkMigrate(resp.removeUser.status)

        if (resp?.removeUser?.status !== 0) {
            throw new Error(resp?.removeUser?.message ?? "Failed to remove user")
        }
    }
    async validateCoupon(coupon: string, isYearly: boolean): Promise<number> {
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            validateCoupon: request.ValidateCoupon.create({
                email: this.email,
                coupon: coupon,
                isYearly: isYearly,
            })
        });
        let resp = await pool.sendAndWait(req);
        if (!resp.validateCoupon || resp.validateCoupon.status !== response.Status.SUCCESS) {
            throw new Error(`Failed to  validate coupon(${resp.validateCoupon?.status})`);
        }
        return resp.validateCoupon.discount;
    }
    async blockUser(email: string): Promise<void> {
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            blockUser: request.BlockUser.create({
                email: email,
            })
        });
        let resp = await pool.sendAndWait(req);
        if (!resp.blockUser || resp.blockUser.status !== response.Status.SUCCESS) {
            throw new Error(`${resp.blockUser?.message}`);
        }
    }
    async unblockUser(email: string): Promise<void> {
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            unblockUser: request.UnblockUser.create({
                email: email,
            })
        });
        let resp = await pool.sendAndWait(req);
        if (!resp.unblockUser || resp.unblockUser.status !== response.Status.SUCCESS) {
            throw new Error(`${resp.unblockUser?.message}`);
        }
    }
}
export class OrgSettings {
    private allowedCountries: string[];
    private deniedCountries: string[];
    private allowedRegions: string[];
    private deniedRegions: string[];
    private allowedFileTypes: string[];
    private deniedFileTypes: string[];

    constructor() {
        this.allowedCountries = [];
        this.deniedCountries = [];
        this.allowedRegions = [];
        this.deniedRegions = [];
        this.allowedFileTypes = [];
        this.deniedFileTypes = [];
    }


    public getAllowedCountries(): string[] {
        return this.allowedCountries;
    }

    public setAllowedCountries(value: string[]): void {
        this.allowedCountries = value;
    }


    public getDeniedCountries(): string[] {
        return this.deniedCountries;
    }

    public setDeniedCountries(value: string[]): void {
        this.deniedCountries = value;
    }


    public getAllowedRegions(): string[] {
        return this.allowedRegions;
    }

    public setAllowedRegions(value: string[]): void {
        this.allowedRegions = value;
    }

    public getDeniedRegions(): string[] {
        return this.deniedRegions;
    }

    public setDeniedRegions(value: string[]): void {
        this.deniedRegions = value;
    }


    public getAllowedFileTypes(): string[] {
        return this.allowedFileTypes;
    }

    public setAllowedFileTypes(value: string[]): void {
        this.allowedFileTypes = value;
    }

    public getDeniedFileTypes(): string[] {
        return this.deniedFileTypes;
    }

    public setDeniedFileTypes(value: string[]): void {
        this.deniedFileTypes = value;
    }

    async updateOrgSettings(): Promise<void> {
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            updateOrgSettings: request.UpdateOrgSettings.create({
                allowedCountries: this.allowedCountries,
                allowedFileTypes: this.allowedFileTypes,
                allowedRegions: this.allowedRegions,
                deniedCountries: this.deniedCountries,
                deniedFileTypes: this.deniedFileTypes,
                deniedRegions: this.deniedRegions,
            })
        });
        let resp = await pool.sendAndWait(req);
        if (!resp.updateOrgSettings || resp.updateOrgSettings.status !== response.Status.SUCCESS) {
            throw new Error(`${resp.updateOrgSettings?.message}`);
        }
    }
    async getOrgSettings(): Promise<OrgSettings> {
        const pool = await getConnectionPool();
        const req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            getOrgSettings: request.GetOrgSettings.create({
            })
        });
        let resp = await pool.sendAndWait(req);
        if (!resp.getOrgSettings || resp.getOrgSettings.status !== response.Status.SUCCESS) {
            throw new Error(`${resp.getOrgSettings?.message}`);
        }
        const settings = new OrgSettings();
        settings.allowedCountries = resp.getOrgSettings.allowedCountries || [];
        settings.allowedRegions = resp.getOrgSettings.allowedRegions || [];
        settings.allowedFileTypes = resp.getOrgSettings.allowedFileTypes || [];
        settings.deniedCountries = resp.getOrgSettings.deniedCountries || [];
        settings.deniedFileTypes = resp.getOrgSettings.deniedFileTypes || [];
        settings.deniedRegions = resp.getOrgSettings.deniedRegions || [];
        return settings;
    }
}